module.exports = {"610431001":"普集街道","610431101":"苏坊镇","610431102":"武功镇","610431103":"游风镇","610431104":"贞元镇","610431105":"长宁镇","610431106":"小村镇","610431107":"大庄镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610431.json
// module id = 2610
// module chunks = 0